import './OHIFLogo.css';

import { Icon } from '@ohif/ui';
import React from 'react';

function OHIFLogo() {
  return (
    <div className="header-brand">
      <Icon name="logo" className="header-logo-image" />
      {/* Logo text would fit smaller displays at two lines:
       *
       * Open Health
       * Imaging Foundation
       *
       * Or as `OHIF` on really small displays
       */}
      <div className="ohif-text-logo" style={{ fontSize: 30 }}>
        影禾AI 阅片器
      </div>
    </div>
  );
}

export default OHIFLogo;
